/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Manage_ButtonInputs */

const en_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Speakers`)
};

const fr_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les locuteurs`)
};

const de_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher verwalten`)
};

const it_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci gli altoparlanti`)
};

const ru_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление спикерами`)
};

const es_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar oradores`)
};

const zh_cn2_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理演讲者`)
};

const ja_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの管理`)
};

const hi_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं का प्रबंधन करें`)
};

const pt_pt2_insert_speaker_manage_button = /** @type {(inputs: Insert_Speaker_Manage_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar Oradores`)
};

/**
* | output |
* | --- |
* | "Manage Speakers" |
*
* @param {Insert_Speaker_Manage_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_manage_button = /** @type {((inputs?: Insert_Speaker_Manage_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Manage_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_manage_button(inputs)
	if (locale === "de") return de_insert_speaker_manage_button(inputs)
	if (locale === "it") return it_insert_speaker_manage_button(inputs)
	if (locale === "ru") return ru_insert_speaker_manage_button(inputs)
	if (locale === "es") return es_insert_speaker_manage_button(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_manage_button(inputs)
	if (locale === "ja") return ja_insert_speaker_manage_button(inputs)
	if (locale === "hi") return hi_insert_speaker_manage_button(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_manage_button(inputs)
	return en_insert_speaker_manage_button(inputs)
});